import { BookWidgetState } from '../../models/states/book-widget-state.interfaces';

export const updateBookWidgetBestFareOptionsFn = (
  state: BookWidgetState,
  selectedBestFare: string
) => {
  const options = [...state.fields.bestFareOptionsField.dropdownOptions];
  const dropdownOptions = options.map((dropdownOption) => {
    if (dropdownOption.value === selectedBestFare) {
      return { ...dropdownOption, selected: true };
    } else {
      return { ...dropdownOption, selected: false };
    }
  });
  return {
    ...state.fields.bestFareOptionsField,
    selectedBestFare,
    dropdownOptions
  };
};
